import { render } from "./UndoRedo.vue?vue&type=template&id=117e865d&scoped=true"
import script from "./UndoRedo.vue?vue&type=script&lang=js"
export * from "./UndoRedo.vue?vue&type=script&lang=js"

import "./UndoRedo.vue?vue&type=style&index=0&id=117e865d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117e865d"]])

export default __exports__